import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import templateHtml from 'templates/main/Modal/ModalPopupView.html';
import defaultFooterTemplate from 'templates/main/Modal/defaultFooterTemplate.html';

var Events = {
    ModalPopupClosed: 'ModalPopupClosed',
    ON_CUSTOM_HEADER_ACTION_CLICKED: 'ON_CUSTOM_HEADER_ACTION_CLICKED',
    CANCEL_CLICKED: 'CANCEL_CLICKED',
    CONFIRM_CLICKED: 'CONFIRM_CLICKED',
    ON_SCROLL: 'ON_SCROLL'
};

var ModalPopupView = Backbone.View.extend({
    modalPopupTemplate: _.template(templateHtml),

    showHeader: true,

    showFooter: true,

    footerTemplate: _.template(defaultFooterTemplate), // The template to use to render the footer

    events: {},

    /**
     * Events  hash that leaves the regular events hash available for derived instances of ModalPopupView.
     */
    baseEvents: {
        'click .js-saveBtn': '_onSaveButtonClicked',
        'click .js-close': '_onCloseButtonClicked',
        'click .cancel': '_onCancelClicked',
        'click .close': 'close',
        'click .js-custom-header-action': 'onCustomHeaderActionClicked',
        click: 'onModalClick'
    },

    initialize: function(args) {
        if (!args.view) {
            throw 'view is required for WidgetSheet';
        }

        this.modalTitle = args.modalTitle; // The title to display in the modal. Can be undefined
        this.isHTMLTitle = args.isHTMLTitle || false; // This is for the case when title has html code in it, in this case it should be used ~ not =.
        this.modalId = args.modalId; // The id of modal
        this.view = args.view; // The view to display in the modal.
        this.customClasses = ''; // Custom classes applied to parent modal div
        this.customBodyClasses = ''; // Custom classes applied to body of modal
        this.customBackdropClasses = ''; // Custom classes applied to the modal's backdrop
        this.options = args.options; // These are options that may be passed into bootstrap
        this.showCloseButton = true; // If true, displays close button (default).
        this.showCancelButton = true; // If true, displays cancel button in footer
        this.isDanger = false; // If true displays save button styled as danger
        this.cancelTextKey = args.cancelTextKey || 'modal_close';
        this.confirmationTextKey = args.confirmationTextKey || 'modal_save';
        this.footerPrimaryButtonClasses = args.footerPrimaryButtonClasses || '';
        this.footerAttributes = args.footerAttributes || '';
        this.closable = _.isUndefined(args.closable) ? true : args.closable;
        this.customHeaderAction = args.customHeaderAction;
        this.stopClickPropagationOnModalClick = args.stopClickPropagationOnModalClick || false;
        this.useCustomBody = _.isUndefined(args.useCustomBody) ? false : args.useCustomBody;
        this.learnMoreUrl = args.learnMoreUrl;

        if (typeof args.showFooter !== 'undefined') {
            this.showFooter = args.showFooter;
        }

        if (typeof args.footerLink !== 'undefined') {
            this.footerLink = args.footerLink;
        }

        if (typeof args.footerTextLink !== 'undefined') {
            this.footerTextLink = args.footerTextLink;
        }

        if (typeof args.showHeader !== 'undefined') {
            this.showHeader = args.showHeader;
        }

        if (typeof args.onSaveButtonClicked !== 'undefined') {
            this.onSaveButtonClicked = args.onSaveButtonClicked;
        } else if (!_.isUndefined(this.view.onSaveButtonClicked) && _.isFunction(this.view.onSaveButtonClicked)) {
            this.onSaveButtonClicked = this.view.onSaveButtonClicked;
        }

        if (!_.isUndefined(args.onCloseButtonClicked) && _.isFunction(args.onCloseButtonClicked)) {
            this.onCloseButtonClicked = args.onCloseButtonClicked;
        } else if (!_.isUndefined(this.view.onCloseButtonClicked) && _.isFunction(this.view.onCloseButtonClicked)) {
            this.onCloseButtonClicked = this.view.onCloseButtonClicked;
        }

        if (typeof args.isDanger !== 'undefined') {
            this.isDanger = args.isDanger;
        }

        if (typeof args.footerTemplate !== 'undefined') {
            this.footerTemplate = args.footerTemplate;
        }

        if (typeof args.customClasses !== 'undefined') {
            this.customClasses = args.customClasses;
        }

        if (typeof args.customBodyClasses !== 'undefined') {
            this.customBodyClasses = args.customBodyClasses;
        }

        if (args.customBackdropClasses !== undefined) {
            this.customBackdropClasses = args.customBackdropClasses;
        }

        if (typeof args.showCloseButton !== 'undefined') {
            this.showCloseButton = args.showCloseButton;
        }

        if (typeof args.showCancelButton !== 'undefined') {
            this.showCancelButton = args.showCancelButton;
        }

        if (typeof args.saveText !== 'undefined') {
            this.saveText = args.saveText;
        }

        if (typeof args.cancelText !== 'undefined') {
            this.cancelText = args.cancelText;
        }

        if (typeof args.showBetaError !== 'undefined') {
            this.showBetaError = args.showBetaError;
        }

        if (this.baseEvents) {
            var events = {};
            for (var prop in this.baseEvents) {
                if (this.baseEvents.hasOwnProperty(prop)) {
                    events[prop] = this.baseEvents[prop];
                }
            }

            this.delegateEvents(_.extend(events, this.events));
        }

        this.parentEl = args.parentEl;

        this.listenTo(this.view, 'ON_CLOSE', this.close);

        Window.App.registerModal(this);

        jQuery(document).on(
            'click',
            '.modal-backdrop',
            function(e) {
                if (this.stopClickPropagationOnModalClick) {
                    e.stopPropagation();
                }
            }.bind(this)
        );
    },

    render: function() {
        var html = this.modalPopupTemplate({
            modalTitle: this.modalTitle,
            isHTMLTitle: this.isHTMLTitle,
            customHeaderAction: this.customHeaderAction,
            showHeader: this.showHeader,
            showFooter: this.showFooter,
            showCloseButton: this.showCloseButton,
            showBetaError: this.showBetaError,
            customBodyClasses: this.customBodyClasses,
            Localizer: Localizer
        });

        if (this.modalId) {
            this.el.setAttribute('id', this.modalId);
        }

        this.$el.addClass('modal hide fade');

        if (this.customClasses) {
            this.$el.addClass(this.customClasses);
        }

        this.$el.html(html);

        jQuery(this.parentEl || 'body').append(this.$el); //moved this up so that modal div is visible/inserted in the DOM before React inner views hosting highcharts are mounted.

        if (this.useCustomBody) {
            this.$('.js-modal-body').replaceWith(this.view.$el.addClass(this.customBodyClasses));
        } else {
            this.$('.js-modal-body').replaceWith(this.view.$el.addClass('modal-body').addClass(this.customBodyClasses));
        }

        this.renderInnerView();
        if (this.showFooter) {
            this.$('.modal-footer').html(
                this.footerTemplate({
                    Localizer: Localizer,
                    showCancelButton: this.showCancelButton,
                    isDanger: this.isDanger,
                    cancel_text_key: this.cancelTextKey,
                    confirmation_text_key: this.confirmationTextKey,
                    footerPrimaryButtonClasses: this.footerPrimaryButtonClasses,
                    footerLink: this.footerLink,
                    footerTextLink: this.footerTextLink,
                    footerAttributes: this.footerAttributes,
                    saveText: this.saveText,
                    cancelText: this.cancelText,
                    learnMoreUrl: this.learnMoreUrl
                })
            );
        }

        var modalOptions = {
            backdrop: this.closable ? true : 'static',
            keyboard: this.closable,
            show: true
        };

        modalOptions = _.extend(modalOptions, this.options);

        jQuery('.modal').modal(modalOptions);
        jQuery('.modal-body').scroll(
            function(e) {
                this.trigger(Events.ON_SCROLL, e);
            }.bind(this)
        );

        if (this.customBackdropClasses) {
            $('.modal-backdrop').addClass(this.customBackdropClasses);
        }

        var _this = this;
        this.$el.attr('tabindex', 0);
        this.$el.focus();
        this.$el.on('hidden.bs.modal', function() {
            //this occurs when the user clicks outside of the modal popup
            //and doing so will closes the modal
            _this.removeView();
        });
    },

    renderInnerView: function() {
        this.view.render();
    },

    removeView: function() {
        this.trigger(Events.ModalPopupClosed);
        this.cleanUpView();
        this.remove();
        this.postRemove();
    },

    postRemove: function() {},

    _onSaveButtonClicked: function(e) {
        e.preventDefault();
        this.trigger(Events.CONFIRM_CLICKED);

        if (this.$(e.target).hasClass('disabled')) {
            return;
        }

        if (this.onSaveButtonClicked) {
            var context = this;
            if (!_.isUndefined(this.view.onSaveButtonClicked) && _.isFunction(this.view.onSaveButtonClicked)) {
                context = this.view;
            }
            if (this.onSaveButtonClicked.call(context)) {
                this.close();
            }
        } else {
            this.close();
        }
    },

    _onCloseButtonClicked: function(e) {
        e.preventDefault();

        if (this.onCloseButtonClicked) {
            var context = this;
            if (!_.isUndefined(this.view.onCloseButtonClicked) && _.isFunction(this.view.onCloseButtonClicked)) {
                context = this.view;
            }
            if (this.onCloseButtonClicked.call(context)) {
                this.close();
            }
        }

        this.cleanUpView();
    },

    _onCancelClicked: function() {
        this.close(() => {
            this.trigger(Events.CANCEL_CLICKED);
        });
    },

    /**
     * May be overridden to handle the save button.
     */
    onSaveButtonClicked: function() {
        return true;
    },
    /**
     * Handler to be called when user clicks the header custom action
     * A parent view can listen to this event and do something at this point
     */
    onCustomHeaderActionClicked: function() {
        this.trigger(Events.ON_CUSTOM_HEADER_ACTION_CLICKED);
    },
    /**
     * It displays the custom header action and hides the hdeader title
     */
    showCustomHeader: function() {
        this.$('.js-custom-header-action').show();
        this.$('.js-modal-header-title').hide();
    },
    /**
     * It hides the Custom Header title and displays header title
     */
    hideCustomHeader: function() {
        this.$('.js-custom-header-action').hide();
        this.$('.js-modal-header-title').show();
    },
    /**
     * Closes this modal.
     */
    close: function(callback) {
        this.$el.on('hidden', () => {
            if (callback && typeof callback === 'function') {
                callback();
            }
            this.unbind();
            this.cleanUpView();
        });
        this.$el.modal('hide');
        if (this.customBackdropClasses) {
            if ($('.modal-backdrop').hasClass(this.customBackdropClasses)) {
                $('.modal-backdrop').removeClass(this.customBackdropClasses);
            }
        }
    },

    cleanUpView: function() {
        //when views have validations and such, those need to be cleaned up
        if (this.view && typeof this.view.destroy === 'function') {
            this.view.destroy();
        }
        jQuery('.tooltip-error').hide();
    },

    disableConfirmationButton: function() {
        var saveButton = this.$('.js-saveBtn');
        saveButton.addClass('disabled');
    },

    enableConfirmationButton: function() {
        var saveButton = this.$('.js-saveBtn');
        if (saveButton.hasClass('disabled')) {
            saveButton.removeClass('disabled');
        }
    },

    onModalClick: function(e) {
        if (this.stopClickPropagationOnModalClick) {
            e.stopPropagation();
        }
    },

    updateFooterPrimaryButtonClasses: function(footerPrimaryButtonClasses) {
        this.$('.modal-footer .btn-primary')
            .removeClass(this.footerPrimaryButtonClasses)
            .addClass(footerPrimaryButtonClasses);
        this.footerPrimaryButtonClasses = footerPrimaryButtonClasses;
    },

    hideHeaderFooter: function() {
        this.$('.modal-header').css('visibility', 'hidden');
        this.$('.modal-footer').css('visibility', 'hidden');
    },

    hideBetaErrorMessage: function() {
        this.$('#beta-error-message').hide();
    },

    showBetaErrorMessage: function() {
        this.$('#beta-error-message').show();
    }
});

ModalPopupView.Events = Events;

export default ModalPopupView;
